import { ApiChainSymbols, ApiCurrencySymbols } from './enums';

export interface CurrencyFeatureFlags {
  widgetSolCurrency: boolean | undefined;
  widgetBnbCurrency: boolean | undefined;
}

export const isFlaggedCurrencyVisible = (
  symbol: string,
  flags: Partial<CurrencyFeatureFlags>
) => {
  if (symbol === ApiCurrencySymbols.SOL) return Boolean(flags.widgetSolCurrency);
  if (symbol === ApiCurrencySymbols.BNB) return Boolean(flags.widgetBnbCurrency);
  return true;
};

export const currencyOrder = [
  ApiCurrencySymbols.USDC,
  ApiCurrencySymbols.BTC,
  ApiCurrencySymbols.ETH,
  ApiCurrencySymbols.SOL,
  ApiCurrencySymbols.BNB,
  ApiCurrencySymbols.POL,
  ApiCurrencySymbols.SUI,
  ApiCurrencySymbols.EGLD,
  ApiCurrencySymbols.DASH,
  ApiCurrencySymbols.USDT,
];

export const blockchainOrder = [
  ApiChainSymbols.ERD,
  ApiChainSymbols.POLYGON,
  ApiChainSymbols.TRX,
  ApiChainSymbols.ETH,
  ApiChainSymbols.BSC,
  ApiChainSymbols.SOLANA,
  ApiChainSymbols.SOL,
  ApiChainSymbols.BTC,
];
